// Signed access to the /weather/* prefix of the marine-weather CDN.
//
// The server mints a short-lived CloudFront signed-URL token (see WeatherCdn and
// Api::WeatherAccessController); this module fetches it once, appends it to
// every weather request, and re-fetches on a 403 so an expiry mid-session
// self-heals instead of leaving the map with empty tiles.
//
// The machinery — the shared in-flight request, the expiry skew, the failure
// quiet period, the throttled 403 refresh, the opaque-CORS belt — lives in
// _cdnToken.js and is shared with the marine prefix. It is unchanged from what
// has run here since 2026-08-25; this file is now the /weather/* configuration
// of it, and `weatherFetch` behaves exactly as it always has.
//
// SIGN AT FETCH TIME, NEVER IN A CACHE KEY — see _cdnToken.js for why that is
// load-bearing for radarGL's texture cache and the pmtiles reader.
//
// Only /weather/* is protected by THIS module. /marine/* has its own token and
// its own key pair (_marineCdn.js); the other prefixes on the distribution
// (sitemaps/, stations/, map-status/) are public on purpose, so weatherFetch
// leaves them completely alone.

import { createCdnFetch } from './_cdnToken'

const weather = createCdnFetch({
  endpoint: '/api/weather_access',
  protectedPath: '/weather/',
})

export const weatherFetch = weather.fetch

// Test seam — resets module state between cases.
export const _test = {
  reset: weather.reset,
  isProtected: weather.isProtected,
  withParams: weather.withParams,
}
